// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0;
  border-bottom: 1px solid #333;
}

.logo {
  font-size: 1.5rem;
  font-weight: bold;
  color: #ff4500;
}

nav a {
  margin-left: 20px;
  color: #ccc;
}

.hero {
  text-align: center;
  padding: 100px 20px;
  background: radial-gradient(circle at center, #1a0b00 0%, #050505 100%);
  border-radius: 16px;
  margin-top: 40px;
}

.hero h1 {
  font-size: 3.5rem;
  margin-bottom: 20px;
}

.hero p {
  font-size: 1.2rem;
  color: #aaa;
  margin-bottom: 40px;
}

.destinations {
  padding: 80px 0;
}

.destinations h2 {
  text-align: center;
  margin-bottom: 40px;
}

.card-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
}

.card {
  background: #111;
  padding: 30px;
  border-radius: 12px;
  border: 1px solid #222;
  text-align: center;
  transition: transform 0.3s;
}

.card:hover {
  transform: translateY(-5px);
  border-color: #ff4500;
}

.success {
  color: #00ff00;
  font-weight: bold;
}

footer {
  text-align: center;
  padding: 40px 0;
  border-top: 1px solid #333;
  margin-top: 60px;
  color: #666;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,uEAAuE;EACvE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,WAAW;AACb","sourcesContent":[".app-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 20px;\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 0;\n  border-bottom: 1px solid #333;\n}\n\n.logo {\n  font-size: 1.5rem;\n  font-weight: bold;\n  color: #ff4500;\n}\n\nnav a {\n  margin-left: 20px;\n  color: #ccc;\n}\n\n.hero {\n  text-align: center;\n  padding: 100px 20px;\n  background: radial-gradient(circle at center, #1a0b00 0%, #050505 100%);\n  border-radius: 16px;\n  margin-top: 40px;\n}\n\n.hero h1 {\n  font-size: 3.5rem;\n  margin-bottom: 20px;\n}\n\n.hero p {\n  font-size: 1.2rem;\n  color: #aaa;\n  margin-bottom: 40px;\n}\n\n.destinations {\n  padding: 80px 0;\n}\n\n.destinations h2 {\n  text-align: center;\n  margin-bottom: 40px;\n}\n\n.card-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 30px;\n}\n\n.card {\n  background: #111;\n  padding: 30px;\n  border-radius: 12px;\n  border: 1px solid #222;\n  text-align: center;\n  transition: transform 0.3s;\n}\n\n.card:hover {\n  transform: translateY(-5px);\n  border-color: #ff4500;\n}\n\n.success {\n  color: #00ff00;\n  font-weight: bold;\n}\n\nfooter {\n  text-align: center;\n  padding: 40px 0;\n  border-top: 1px solid #333;\n  margin-top: 60px;\n  color: #666;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
